
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { ArrowRight, Edit3, FileText, Image, Link2Icon, Settings, LucideIcon } from "lucide-react";

interface QuickAccessCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  href: string;
}

const QuickAccessCard = ({ title, description, icon: Icon, href }: QuickAccessCardProps) => (
  <Card className="overflow-hidden transition-all hover:shadow-md group">
    <Link to={href}>
      <CardHeader className="bg-gray-50 space-y-1 pb-2">
        <CardTitle className="text-base flex items-center">
          <Icon className="w-4 h-4 mr-2 text-gray-500" />
          {title}
        </CardTitle>
        <CardDescription className="text-xs">{description}</CardDescription>
      </CardHeader>
      <CardContent className="pt-4 pb-2">
        <div className="flex items-center text-sm text-primary font-medium">
          Go to {title.toLowerCase()}
          <ArrowRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" />
        </div>
      </CardContent>
    </Link>
  </Card>
);

const QuickAccessCards = () => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 mb-8">
      <QuickAccessCard
        title="Blog Posts"
        description="Create and manage your blog content"
        icon={FileText}
        href="/admin/blog"
      />
      <QuickAccessCard
        title="Image Repository"
        description="Upload and manage your image assets"
        icon={Image}
        href="/admin/image-repository"
      />
      <QuickAccessCard
        title="Tool Configuration"
        description="Manage interactive tools settings"
        icon={Settings}
        href="/admin/tools"
      />
      <QuickAccessCard
        title="Create New Post"
        description="Start writing a new blog post"
        icon={Edit3}
        href="/admin/new-post"
      />
      <QuickAccessCard
        title="URL Redirects"
        description="Manage URL redirects for SEO"
        icon={Link2Icon}
        href="/admin/redirects"
      />
    </div>
  );
};

export default QuickAccessCards;
